import {Component, OnInit} from '@angular/core';
import {CargoEntity, GrupoCargoEntity, PorcentajeComision} from '../../CoreModule/entities/cargo.entity';
import {CargoServices} from '../../CoreModule/services/cargo.services';
import {ActivatedRoute} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {OPCNEG} from '../../variables';

@Component({
  selector:"cargos-list",
  templateUrl:"../templates/cargos/cargo.list.template.html"
})
export class CargosCrudComponent implements OnInit{
  public cargos:CargoEntity[] = [];

  constructor(private cs:CargoServices, private spinner:NgxSpinnerService){}

  ngOnInit(): void {
    this.spinner.show();
    this.cs.getCargos().subscribe((d:any)=>{
      // console.log(d);
      this.spinner.hide();
      console.log(d);
      this.cargos = d.data.cargos;
    })
  }

  duplicarCargo(c:CargoEntity){
    this.spinner.show();
    this.cs.duplicarCargo(c._id).subscribe(d=>{
      console.log(d);
      this.cs.getCargos().subscribe((d:any)=>{
        this.spinner.hide();
        this.cargos = d.data.cargos;
      })
    })
  }


}

@Component({
  selector:"cargo-new",
  templateUrl:"../templates/cargos/cargo.new.template.html"
})
export class CargosNewComponent implements OnInit{

  public cargo:CargoEntity = new CargoEntity();

  constructor(private cs:CargoServices, private spinner:NgxSpinnerService){}

  ngOnInit(): void {
  }

  agregarPorcentaje(categoria:string){
    switch (categoria) {
      case "A":
        this.cargo.A.porcentajes.push(new PorcentajeComision());
        break;
      case "AA":
        this.cargo.AA.porcentajes.push(new PorcentajeComision());
        break;
      case "AAA":
        this.cargo.AAA.porcentajes.push(new PorcentajeComision());
        break;

    }
  }

  quitarPorcentaje(categoria:string, porcentaje:PorcentajeComision){
    switch (categoria) {
      case "A":
        this.cargo.A.porcentajes = this.cargo.A.porcentajes.filter(p=> p!= porcentaje);
        break;
      case "AA":
        this.cargo.AA.porcentajes = this.cargo.AA.porcentajes.filter(p=> p!= porcentaje);
        break;
      case "AAA":
        this.cargo.AAA.porcentajes = this.cargo.AAA.porcentajes.filter(p=> p!= porcentaje);
        break;

    }
  }


  guardarCargo(){
    this.spinner.show();
    this.cs.newCargo(this.cargo).subscribe(d=>{
      console.log(d);
      this.spinner.hide();
      alert("Cargo creado con exito");
    })
  }
}

@Component({
  selector:"cargos-edit",
  templateUrl:"../templates/cargos/cargo.edit.template.html"
})
export class CargosEditComponent implements OnInit{
  public cargo:CargoEntity;
  public grupos:GrupoCargoEntity[] = [];
  opcNegocio: string[] = OPCNEG;

  constructor(private cs:CargoServices, private activeRouter:ActivatedRoute, private spinner:NgxSpinnerService){}

  ngOnInit(): void {
    let id = this.activeRouter.snapshot.params.id;

    this.spinner.show();
    this.cs.getCargo(id).subscribe((d:any)=>{

      this.cargo = d.data.cargo;

      console.log(this.cargo);



      this.cs.getGruposCargos().subscribe((d2:any)=>{

        this.grupos = d2.data.gruposCargos;


        this.cargo.grupo = this.grupos.find(g=> g._id == this.cargo.grupo._id);

        this.grupos.forEach(g=>{
          delete g.tiendas;
        });

        this.spinner.hide();
      });

    })
  }

  cambioGrupo($event){
    console.log($event);
  }

  devolverSelect(grupo):boolean{
    if(this.cargo.grupo)
      return this.cargo.grupo._id == grupo._id;
    else
      return  false;
  }

  agregarPorcentaje(categoria:string){
    switch (categoria) {
      case "A":
        this.cargo.A.porcentajes.push(new PorcentajeComision());
        break;
      case "AA":
        this.cargo.AA.porcentajes.push(new PorcentajeComision());
        break;
      case "AAA":
        this.cargo.AAA.porcentajes.push(new PorcentajeComision());
        break;

    }
  }

  quitarPorcentaje(categoria:string, porcentaje:PorcentajeComision){
    switch (categoria) {
      case "A":
        this.cargo.A.porcentajes = this.cargo.A.porcentajes.filter(p=> p!= porcentaje);
        break;
      case "AA":
        this.cargo.AA.porcentajes = this.cargo.AA.porcentajes.filter(p=> p!= porcentaje);
        break;
      case "AAA":
        this.cargo.AAA.porcentajes = this.cargo.AAA.porcentajes.filter(p=> p!= porcentaje);
        break;

    }
  }


  actualizarCargo(){

    this.spinner.show();
    console.log(this.cargo);
    this.cs.editCargo(this.cargo).subscribe(d=>{
      console.log(d);
      this.spinner.hide();
      alert("Cargo actualizado con exito");
    })
  }
}
